module.exports = __webpack_public_path__ + "img/clientIcon.53311323.png";